import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

// Material UI
import Fab from '@mui/material/Fab';

// Icons
import VerticalAlignBottomOutlinedIcon from '@mui/icons-material/VerticalAlignBottomOutlined';
import VerticalAlignTopOutlinedIcon from '@mui/icons-material/VerticalAlignTopOutlined';
import { Paper, Typography, Grid } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';

// Components
import { DataGrid, ViewButton, EditButton, FabContainer } from '@arredo/reactjs-ui';
import MovementFilters from "./MovementsFilter";

// Hooks
import useMovements from "../../../hooks/movements/useMovements";
import useAuthorize from "../../../hooks/user/useAuthorize";
import useStyles from './styles';

// Models
import { columns, states, subTypes } from "../../../models/MovementEntity";
import { Permissions } from '../../../models/Roles';


const Movements = () => {
    const { classes } = useStyles();
    const navigate  = useNavigate();
    const { movements, loading, totalPage, filters, search, clearFilters, setParameterSearch } = useMovements();
    const isAuthorized = useAuthorize();
    const [anchorEl, setAnchorEl] = useState(false);
    const [anchorEE, setAnchorEE] = useState(false);

    const handleChangePage = (e, page) =>
        setParameterSearch({ pageNumber: Number(page) });

    const handleChangeFilters = (filters) =>
        setParameterSearch({ ...filters, pageNumber: 1 });

    const renderButtonAdmin = () =>
        <>
            <Fab
                color='primary'
                variant="extended"
                className={classes.fab}
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={(event) => setAnchorEE(event.currentTarget)}
            >
                <VerticalAlignTopOutlinedIcon />
                Egreso
            </Fab>
            <Menu
                anchorEl={anchorEE}
                keepMounted
                open={Boolean(anchorEE)}
                onClose={() => setAnchorEE(false)}
            >
                <MenuItem onClick={() => navigate('/movements/adjustment/egrees')}>
                    <ListItemIcon>
                        <VerticalAlignTopOutlinedIcon />
                    </ListItemIcon>
                    <Typography variant="inherit">Ajustes</Typography>
                </MenuItem>
                <MenuItem onClick={() => navigate('/movements/egress')}>
                    <ListItemIcon>
                        <VerticalAlignTopOutlinedIcon />
                    </ListItemIcon>
                    <Typography variant="inherit">Despacho</Typography>
                </MenuItem>
            </Menu>
            <Fab
                color='primary'
                variant="extended"
                className={classes.fab}
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={(event) => setAnchorEl(event.currentTarget)}
            >
                <VerticalAlignBottomOutlinedIcon />
                Ingreso
            </Fab>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(false)}
            >
                <MenuItem onClick={() => navigate('/movements/adjustment/ingress')}>
                    <ListItemIcon>
                        <VerticalAlignBottomOutlinedIcon />
                    </ListItemIcon>
                    <Typography variant="inherit">Ajuste</Typography>
                </MenuItem>
                <MenuItem onClick={() => navigate('/movements/reception')}>
                    <ListItemIcon>
                        <VerticalAlignBottomOutlinedIcon />
                    </ListItemIcon>
                    <Typography variant="inherit">Recepción</Typography>
                </MenuItem>
            </Menu>
        </>

    return (
        <>
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Paper className={classes.paper}>
                        <Typography variant="h4">
                            Movimientos
                        </Typography>
                    </Paper>
                </Grid>

                <Grid size={12}>
                    <MovementFilters
                        filters={filters}
                        setFilters={handleChangeFilters}
                        clearFilters={clearFilters}
                    />
                </Grid>

                <Grid size={12}>
                    <DataGrid
                        columns={columns}
                        loading={loading}
                        rows={movements}
                        paginationProps={{
                            count: totalPage,
                            page: filters?.pageNumber || 1,
                            onChange: handleChangePage
                        }}
                        actions={({ row }) => (
                            <>
                                <ViewButton to={`/movements/detail/${row.id}`} from={`/movements${search}`} />
                                {
                                    row.state === states.Pending &&
                                    (row.subType === subTypes.Adjustment ||
                                        row.subType === subTypes.Transfer) &&
                                    <EditButton to={`/movements/${row.type}/${row.id}`} />
                                }
                            </>
                        )}
                    />
                </Grid>
            </Grid>

            <FabContainer>
                {
                    isAuthorized([Permissions.StockCreate, Permissions.StockAuditor]) &&
                    renderButtonAdmin()
                }
            </FabContainer>
        </>
    );
}

export default Movements;